import { render, staticRenderFns } from "./NominacionForm.vue?vue&type=template&id=69d8bc82"
import script from "./NominacionForm.vue?vue&type=script&lang=js"
export * from "./NominacionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports